/**
 * Sprint App native — Lot 3. Constantes de plateforme, résolues AU BUILD.
 *
 * Volontairement sans import Capacitor : ce module est lu par `client.js`, le
 * bandeau d'environnement et `useIsMobile`, donc par le bundle web. Vite
 * remplace `import.meta.env.*` par des littéraux ⇒ en build web, toutes les
 * branches natives sont du code mort et disparaissent du bundle.
 *
 * Variables (fichiers `.env.native-staging` / `.env.native-production`) :
 *  - VITE_NATIVE=1               active le mode coquille native ;
 *  - VITE_API_BASE_URL           origine absolue de l'API synolog ;
 *  - VITE_CORE_BASE_URL          origine de synocore (lue par client.js) ;
 *  - VITE_APP_ENV                staging | production (bandeau d'env) ;
 *  - VITE_MOBILE_CLIENT_ID       client OAuth public déclaré dans synocore ;
 *  - VITE_MOBILE_REDIRECT_URI    schéma privé de retour dans l'app.
 */
export const IS_NATIVE = import.meta.env.VITE_NATIVE === '1';

/** Origine de l'API en natif (la WebView sert l'app depuis capacitor://localhost). */
export const NATIVE_API_ORIGIN = IS_NATIVE
  ? (import.meta.env.VITE_API_BASE_URL || '').replace(/\/+$/, '')
  : '';

export const NATIVE_APP_ENV = IS_NATIVE ? import.meta.env.VITE_APP_ENV || 'production' : null;

export const MOBILE_CLIENT_ID = import.meta.env.VITE_MOBILE_CLIENT_ID || 'synolog-mobile';
export const MOBILE_REDIRECT_URI =
  import.meta.env.VITE_MOBILE_REDIRECT_URI || 'ch.synotis.synolog://auth/callback';
